// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-control {
  margin-top: 5px;
  height: 50px;
  width: 250px;
  position: fixed;
  transform: translateX(-50%);
  left: 46%;
  top: 0;
}

.control-content {
  position: fixed;
  left: 0;
  top: 60px;
  width: 100vw;
  height: calc(100vh - 70px);
  padding-left: 15px;
  padding-right: 15px;
  box-sizing: border-box;
  overflow: hidden;
  font-size: 14px;
}

.control-filters {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  font-size: 15px;
  width: 100%;
}

.vehicle-select {
  display: flex;
  justify-content: space-between;
  margin-bottom:10px;
}

.vehicle-filter {
  flex: 1 1;
  margin-right: 10px;
  font-size: 15px;
  width: 30vw;
}

.vehicle-select select {
  flex-grow: 1;
  font-size: 15px;
  margin-right: 10px;
  padding: 1px;
  width: 30vw;
}

.vehicle-select button {
  padding: 1px;
  font-size: 15px;
  font-weight: bold;
}

.control-table-container {
  overflow-x: auto;
  overflow-y: auto;
  height: calc(100% - 70px);
}

.control-table {
  width: 100%; /* Mantener el ancho total de la tabla */
  table-layout: fixed; /* Forzar que las columnas tengan un ancho fijo */
  border-collapse: collapse;
}

.control-table th, 
.control-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
  white-space: normal; /* Permitir que el texto se ajuste */
  word-wrap: break-word; /* Forzar el salto de línea si es necesario */
  overflow: hidden; /* Ocultar cualquier desbordamiento */
}

.control-table th {
  background-color: #f2f2f2;
  font-weight: bold;
  position: sticky;
  top: 0;
  z-index: 1;
}

.loading-spinner {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.error-message {
  color: red;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.map-overlay {
  position: fixed;
  top: 155px;
  left: 14px;
  width: calc(100% - 28px);
  height: calc(100% - 165px);
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.closeButton {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 5px 10px;
  background-color: red;
  border: 2px solid #FFF;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
  z-index: 1001;
}

.message-filter {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.message-filter label {
  font-weight: bold;
  margin-right: 10px;
}

.message-filter input {
  width: 100%;
  padding: 2px;
  font-size: 14px;
}

/* Añadido para centrar el botón ENVIAR */
.control-table td:last-child {
  text-align: center; /* Centrado horizontal */
  vertical-align: middle; /* Centrado vertical */
}

.control-table button {
  padding: 5px 10px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  display: inline-block; /* Respetar el centrado */
  border-radius: 15px;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/Control.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,SAAS;EACT,MAAM;AACR;;AAEA;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW,EAAE,wCAAwC;EACrD,mBAAmB,EAAE,iDAAiD;EACtE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB,EAAE,oCAAoC;EACzD,qBAAqB,EAAE,6CAA6C;EACpE,gBAAgB,EAAE,qCAAqC;AACzD;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,UAAU;EACV,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB,EAAE,wBAAwB;EAC5C,sBAAsB,EAAE,sBAAsB;AAChD;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,qBAAqB,EAAE,yBAAyB;EAChD,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".banner-control {\n  margin-top: 5px;\n  height: 50px;\n  width: 250px;\n  position: fixed;\n  transform: translateX(-50%);\n  left: 46%;\n  top: 0;\n}\n\n.control-content {\n  position: fixed;\n  left: 0;\n  top: 60px;\n  width: 100vw;\n  height: calc(100vh - 70px);\n  padding-left: 15px;\n  padding-right: 15px;\n  box-sizing: border-box;\n  overflow: hidden;\n  font-size: 14px;\n}\n\n.control-filters {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n  font-size: 15px;\n  width: 100%;\n}\n\n.vehicle-select {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom:10px;\n}\n\n.vehicle-filter {\n  flex: 1;\n  margin-right: 10px;\n  font-size: 15px;\n  width: 30vw;\n}\n\n.vehicle-select select {\n  flex-grow: 1;\n  font-size: 15px;\n  margin-right: 10px;\n  padding: 1px;\n  width: 30vw;\n}\n\n.vehicle-select button {\n  padding: 1px;\n  font-size: 15px;\n  font-weight: bold;\n}\n\n.control-table-container {\n  overflow-x: auto;\n  overflow-y: auto;\n  height: calc(100% - 70px);\n}\n\n.control-table {\n  width: 100%; /* Mantener el ancho total de la tabla */\n  table-layout: fixed; /* Forzar que las columnas tengan un ancho fijo */\n  border-collapse: collapse;\n}\n\n.control-table th, \n.control-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n  white-space: normal; /* Permitir que el texto se ajuste */\n  word-wrap: break-word; /* Forzar el salto de línea si es necesario */\n  overflow: hidden; /* Ocultar cualquier desbordamiento */\n}\n\n.control-table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.loading-spinner {\n  text-align: center;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.error-message {\n  color: red;\n  text-align: center;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.map-overlay {\n  position: fixed;\n  top: 155px;\n  left: 14px;\n  width: calc(100% - 28px);\n  height: calc(100% - 165px);\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.closeButton {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  padding: 5px 10px;\n  background-color: red;\n  border: 2px solid #FFF;\n  border-radius: 50%;\n  cursor: pointer;\n  font-size: 16px;\n  z-index: 1001;\n}\n\n.message-filter {\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n}\n\n.message-filter label {\n  font-weight: bold;\n  margin-right: 10px;\n}\n\n.message-filter input {\n  width: 100%;\n  padding: 2px;\n  font-size: 14px;\n}\n\n/* Añadido para centrar el botón ENVIAR */\n.control-table td:last-child {\n  text-align: center; /* Centrado horizontal */\n  vertical-align: middle; /* Centrado vertical */\n}\n\n.control-table button {\n  padding: 5px 10px;\n  font-size: 15px;\n  font-weight: bold;\n  cursor: pointer;\n  display: inline-block; /* Respetar el centrado */\n  border-radius: 15px;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
